<script setup lang="ts">
// types
import type { HeaderDesktopNavItemProps } from '@composables/widgets/headers/header-desktop-nav-item.hook'
// constants
import { STRAPI_HEADER_ITEM_TYPE } from '@ts-strapi/enums'
// hooks
import { useHeaderDesktopNavItem } from '@composables/widgets/headers/header-desktop-nav-item.hook'
// assets
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
// components
import { AppText } from '@UI/Typography/AppText'
import { AppIcon } from '@UI/Icons/AppIcon'
import { LinkBase } from '@UI/Links/LinkBase'
import HeaderMultipleMenu from '@Widgets/Headers/HeaderMultipleMenu.vue'
import HeaderSingleMenu from '@Widgets/Headers/HeaderSingleMenu.vue'

defineOptions({
  name: 'HeaderDesktopNavItem',
})

const props = defineProps<HeaderDesktopNavItemProps>()

const emit = defineEmits<{
  'click:open': []
  'click:close': []
}>()

const {
  refIsMega,
  handleMouseEnter,
  handleMouseLeave,
  handleClick,
} = useHeaderDesktopNavItem({
  props,
  onOpen: () => emit('click:open'),
  onClose: () => emit('click:close'),
})
</script>

<template>
  <div
    class="header-nav-item"
    :class="{ 'header-nav-item--open': isOpen }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <LinkBase
      v-if="item.__component === STRAPI_HEADER_ITEM_TYPE.SimpleLink"
      :link="{ label: item.label, url: item.url, newTab: item.newTab }"
      class="header-nav-item__label"
    >
      <AppText
        tag="span"
        name="body3-medium"
        color="slate-900"
      >
        {{ item.label }}
      </AppText>
    </LinkBase>

    <button
      v-else
      type="button"
      class="header-nav-item__label header-nav-item__label--mega"
      :aria-expanded="isOpen"
      @click="handleClick"
    >
      <AppText
        tag="span"
        name="body3-medium"
        color="slate-900"
      >
        {{ item.label }}
      </AppText>
      <AppIcon
        class="header-nav-item__chevron"
        :icon="faChevronDown"
        size="small"
      />
    </button>

    <Transition name="header-nav-item-panel">
      <div
        v-if="refIsMega && isOpen"
        class="header-nav-item__panel"
      >
        <HeaderMultipleMenu
          v-if="item.__component === STRAPI_HEADER_ITEM_TYPE.MultipleMenu"
          :item="item"
        />
        <HeaderSingleMenu
          v-else-if="item.__component === STRAPI_HEADER_ITEM_TYPE.SingleMenu"
          :item="item"
        />
      </div>
    </Transition>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderDesktopNavItem.scss" />